import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Popover from "@mui/material/Popover";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { SketchPicker } from "react-color";
import { useDispatch, useSelector } from "react-redux";
import { setUsuario } from "../../Usuario/actions/actions";
import { save } from "../../Instituicao/api-instituicao";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import { success } from "../../../util/ToastUtil";
import SettingsCard from "../SettingsCard";

const CAMPOS = [
  { name: "corPrimaria", label: "Cor primária" },
  { name: "corSecundaria", label: "Cor secundária" },
];

const SystemColors = () => {
  const usuario = useSelector((state) => state.usuario);
  const dispatch = useDispatch();
  const instituicao = usuario.instituicao;
  // Cores salvas: as alterações abaixo são aplicadas ao tema na hora (pré-visualização).
  const [salvas, setSalvas] = useState(() => ({
    corPrimaria: instituicao.corPrimaria ?? null,
    corSecundaria: instituicao.corSecundaria ?? null,
  }));
  const [picker, setPicker] = useState({ anchorEl: null, name: null });
  const [isSaving, setIsSaving] = useState(false);

  const hasChanges = CAMPOS.some(({ name }) => (instituicao[name] ?? null) !== salvas[name]);

  const updateCores = (cores) => {
    dispatch(setUsuario({ ...usuario, instituicao: { ...instituicao, ...cores } }));
  };

  const handleSave = () => {
    setIsSaving(true);
    save(instituicao)
      .then((data) => {
        if (!data) return;
        if (data.error) {
          errorMessage(data.message);
          return;
        }
        setSalvas({ corPrimaria: instituicao.corPrimaria ?? null, corSecundaria: instituicao.corSecundaria ?? null });
        success("Cores salvas.");
      })
      .finally(() => setIsSaving(false));
  };

  return (
    <SettingsCard
      title="Cores do Sistema"
      description="As alterações aparecem na hora, mas só valem para todos depois de salvar."
      contentPadding={false}
    >
      <Stack divider={<Divider />}>
        {CAMPOS.map(({ name, label }) => (
          <Stack key={name} direction="row" alignItems="center" spacing={2} px={2.5} py={1.5}>
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: 1.5,
                border: 1,
                borderColor: "divider",
                bgcolor: instituicao[name] || "background.default",
                flexShrink: 0,
              }}
            />
            <Stack flexGrow={1} minWidth={0}>
              <Typography variant="body2" fontWeight={500}>
                {label}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {instituicao[name] || "Padrão do sistema"}
              </Typography>
            </Stack>
            <Button size="small" onClick={(event) => setPicker({ anchorEl: event.currentTarget, name })}>
              Alterar
            </Button>
            <Button
              size="small"
              color="inherit"
              disabled={!instituicao[name]}
              onClick={() => updateCores({ [name]: null })}
            >
              Padrão
            </Button>
          </Stack>
        ))}
      </Stack>
      <Divider />
      <Stack direction="row" spacing={1} justifyContent="flex-end" px={2.5} py={1.5}>
        <Button color="inherit" disabled={!hasChanges || isSaving} onClick={() => updateCores(salvas)}>
          Descartar
        </Button>
        <Button variant="contained" disabled={!hasChanges || isSaving} onClick={handleSave}>
          Salvar
        </Button>
      </Stack>

      <Popover
        open={Boolean(picker.anchorEl)}
        anchorEl={picker.anchorEl}
        onClose={() => setPicker({ anchorEl: null, name: null })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {picker.name && (
          <SketchPicker
            disableAlpha
            color={instituicao[picker.name] || "#FFFFFF"}
            onChangeComplete={(color) => updateCores({ [picker.name]: color.hex })}
          />
        )}
      </Popover>
    </SettingsCard>
  );
};

export default SystemColors;
